/* ==========================================================================
   Palmora — nhóm sections-b:
   1) Video trong "Media + chữ": chỉ phát khi nằm trong màn hình, nút phát/tạm dừng,
      prefers-reduced-motion => dừng ngay và chờ người xem bấm phát.
   2) "Mục mở rộng" (accordion): chế độ chỉ mở một mục; mở mục khi chọn block trong Customizer.
   JS thuần, bọc IIFE, an toàn khi không có phần tử, chạy được nhiều instance.
   File có thể bị nạp nhiều lần (mỗi section chèn một thẻ script) nên chỉ khởi tạo
   một lần; các lần sau chỉ quét lại DOM (idempotent qua data-pm-ready).
   ========================================================================== */
(function () {
  'use strict';

  if (window.PalmoraSectionsB && typeof window.PalmoraSectionsB.init === 'function') {
    window.PalmoraSectionsB.init(document);
    return;
  }

  var motionQuery = null;
  try {
    motionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  } catch (e) {
    motionQuery = null;
  }

  function reducedMotion() {
    return !!(motionQuery && motionQuery.matches);
  }

  /* Tìm phần tử khớp selector trong scope, kể cả chính scope */
  function findAll(scope, selector) {
    var root = scope || document;
    var list = Array.prototype.slice.call(root.querySelectorAll ? root.querySelectorAll(selector) : []);
    if (root.matches && root.matches(selector)) list.unshift(root);
    return list;
  }

  /* ------------------------------------------------------------------
     1) VIDEO TRONG "MEDIA + CHỮ"
     ------------------------------------------------------------------ */
  var players = [];
  var observer = null;

  function Player(media) {
    this.media = media;
    this.video = media.querySelector('[data-pm-mt-video]');
    this.toggle = media.querySelector('[data-pm-mt-toggle]');
    /* wantPlay: video "nên" chạy khi nằm trong màn hình
       (tự phát khi được bật, hoặc người xem đã bấm phát) */
    this.wantPlay = this.video.hasAttribute('data-pm-mt-autoplay') && !reducedMotion();
    this.bind();

    if (!this.wantPlay) {
      /* Giảm chuyển động hoặc tắt tự phát: gỡ autoplay và dừng ngay
         (pause() cũng chặn trình duyệt tự phát về sau) */
      this.video.removeAttribute('autoplay');
      this.pause();
    }

    if (observer) {
      observer.observe(this.media);
    } else if (this.wantPlay) {
      this.play();
    }
    this.sync();
  }

  Player.prototype.play = function () {
    var self = this;
    var result;
    try {
      result = this.video.play();
    } catch (e) {
      result = null;
    }
    /* Trình duyệt chặn tự phát: giữ trạng thái dừng, nút hiện "Phát" */
    if (result && typeof result.catch === 'function') {
      result.catch(function () { self.sync(); });
    }
  };

  Player.prototype.pause = function () {
    try { this.video.pause(); } catch (e) { /* bỏ qua */ }
  };

  Player.prototype.sync = function () {
    var playing = !this.video.paused && !this.video.ended;
    this.media.classList.toggle('is-playing', playing);
    if (this.toggle) {
      var label = this.toggle.getAttribute(playing ? 'data-label-pause' : 'data-label-play');
      if (label) this.toggle.setAttribute('aria-label', label);
    }
  };

  Player.prototype.setVisible = function (visible) {
    if (visible) {
      if (this.wantPlay && this.video.paused) this.play();
    } else if (!this.video.paused) {
      this.pause();
    }
  };

  Player.prototype.bind = function () {
    var self = this;
    ['play', 'playing', 'pause', 'ended'].forEach(function (type) {
      self.video.addEventListener(type, function () { self.sync(); });
    });
    if (this.toggle) {
      this.toggle.addEventListener('click', function () {
        if (self.video.paused) {
          self.wantPlay = true;
          self.play();
        } else {
          self.wantPlay = false;
          self.pause();
        }
      });
    }
  };

  function playerFor(media) {
    for (var i = 0; i < players.length; i++) {
      if (players[i].media === media) return players[i];
    }
    return null;
  }

  function initVideos(scope) {
    if (!observer && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var player = playerFor(entry.target);
          if (player) player.setVisible(entry.isIntersecting);
        });
      }, { threshold: 0.25 });
    }

    findAll(scope, '[data-pm-section="media-text"] [data-pm-mt-media]').forEach(function (media) {
      if (media.getAttribute('data-pm-ready') === '1') return;
      if (!media.querySelector('[data-pm-mt-video]')) return;
      media.setAttribute('data-pm-ready', '1');
      players.push(new Player(media));
    });
  }

  /* Người xem bật giảm chuyển động khi trang đang mở: dừng mọi video đang tự phát */
  function onMotionChange() {
    if (!reducedMotion()) return;
    players.forEach(function (player) {
      player.wantPlay = false;
      player.pause();
    });
  }
  if (motionQuery) {
    if (typeof motionQuery.addEventListener === 'function') {
      motionQuery.addEventListener('change', onMotionChange);
    } else if (typeof motionQuery.addListener === 'function') {
      motionQuery.addListener(onMotionChange);
    }
  }

  /* Gỡ các player của section đã bị trình chỉnh sửa theme xoá/tải lại */
  function prunePlayers() {
    players = players.filter(function (player) {
      if (document.documentElement.contains(player.media)) return true;
      if (observer) observer.unobserve(player.media);
      return false;
    });
  }

  /* ------------------------------------------------------------------
     2) MỤC MỞ RỘNG (ACCORDION)
     <details> tự chạy không cần JS; JS chỉ thêm chế độ "mở một mục".
     ------------------------------------------------------------------ */
  function initAccordions(scope) {
    findAll(scope, '[data-pm-section="accordion"] [data-pm-acc-list]').forEach(function (list) {
      if (list.getAttribute('data-pm-ready') === '1') return;
      list.setAttribute('data-pm-ready', '1');
      if (list.getAttribute('data-pm-acc-list') !== 'single') return;

      var items = Array.prototype.slice.call(list.querySelectorAll('[data-pm-acc-item]'));
      items.forEach(function (item) {
        /* Sự kiện toggle không nổi bọt nên gắn cho từng mục */
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) {
            if (other !== item && other.open) other.open = false;
          });
        });
      });
    });
  }

  /* ------------------------------------------------------------------
     3) KHỞI TẠO + SỰ KIỆN CỦA TRÌNH CHỈNH SỬA THEME
     ------------------------------------------------------------------ */
  function init(scope) {
    try { prunePlayers(); } catch (e) { /* không để lỗi lan ra trang */ }
    try { initVideos(scope || document); } catch (e) { /* như trên */ }
    try { initAccordions(scope || document); } catch (e) { /* như trên */ }
  }

  window.PalmoraSectionsB = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });

  document.addEventListener('shopify:section:unload', function () {
    /* Section bị gỡ khỏi DOM sau sự kiện này: dọn ở lần init kế tiếp */
    setTimeout(function () {
      try { prunePlayers(); } catch (e) { /* bỏ qua */ }
    }, 0);
  });

  /* Chọn một mục accordion trong Customizer => mở mục đó */
  document.addEventListener('shopify:block:select', function (event) {
    var target = event.target;
    if (target && target.matches && target.matches('[data-pm-acc-item]')) {
      target.open = true;
    }
  });
})();
